const BalanceTransactionCards = ({
    combinedRows = [],
    activeTab,
    handleRowClick,
    selectedRow
}) => {
    const filteredRows = combinedRows.filter(row => {
        return activeTab === 'invoices' ? row.type === 'Invoice' : row.type === 'Payment';
    });

    return (
        <div className="card-table-container flex flex-col gap-[15px] md:hidden mt-[15px]">
            {filteredRows.length === 0 ? (
                <p className="info-text text-center">No data found</p>
            ) : (
                filteredRows.map((row) => (
                    <div
                        key={row.id}
                        onClick={() => handleRowClick(row)}
                        className={`border border-gray-300 rounded-lg p-6 w-full cursor-pointer ${selectedRow?.id === row.id ? 'bg-gray-100' : ''}`}
                    >
                        <div className="detail-column">
                            <p className="detail-label">Reference No.</p>
                            <p className="detail">{row.reference}</p>
                        </div>
                        <div className="detail-row -mt-[10px]">
                            <div className="detail-column mb-[-20px]">
                                <p className="detail-label">Date Created</p>
                                <p className="detail">{new Date(row.createdAt).toLocaleDateString()}</p>
                            </div>
                            <div className="detail-column mb-[-20px]">
                                <p className="detail-label">Amount</p>
                                <p className="detail">PHP {row.amount?.toLocaleString()}</p>
                            </div>
                        </div>

                        {row.isInvoice && (
                            <div className="detail-column mt-[15px]">
                                <p className="detail-label">Status</p>
                                <p className="detail">
                                    {row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : '-'}
                                </p>
                            </div>
                        )}
                    </div>
                ))
            )}
        </div>
    );
};

export default BalanceTransactionCards;
